function htmlViewer() {
	function link(scope, element) {
		const iframe = document.createElement("iframe");
		const element0 = element[0];
		element0.appendChild(iframe);

		scope.$watch("content", function() {
			iframe.contentWindow.document.open("text/htmlreplace");
			iframe.contentWindow.document.write(scope.content);
			iframe.contentWindow.document.close();
		});
	}

	return {
		link: link,
		restrict: "E",
		scope: {
			content: "="
		}
	};
}

export default angular.module("vesl.behaviors.html-viewer", []).directive("htmlViewer", htmlViewer).name;
